/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Document status
 */
export type DocumentStatus = 'Uploading' | 'Pending' | 'Accepted' | 'Rejected' | 'Expired';

export const DocumentStatus = {
    Uploading: 'Uploading' as DocumentStatus,
    Pending: 'Pending' as DocumentStatus,
    Accepted: 'Accepted' as DocumentStatus,
    Rejected: 'Rejected' as DocumentStatus,
    Expired: 'Expired' as DocumentStatus
};